export class ShiftAccumulationType {
	constructor() {
	}
} 
